export default {
  name: "CustomInputFile",
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: "Upload",
    },
    resetTrigger: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      fileName: null,
      file: null,
    };
  },
  watch: {
    resetTrigger(newVal) {
      if (newVal) {
        this.resetFile();
      }
    },
  },
  methods: {
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.fileName = file.name;
        this.file = file;
        this.$emit("file-selected", file);
      }
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    removeFile() {
      this.resetFile();
      this.$emit("file-removed");
    },
    resetFile() {
      this.fileName = null;
      this.file = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = "";
      }
    },
  },
};
